import React, { FunctionComponent, useState, useCallback } from 'react';

import { Button } from 'react-bootstrap';
import { trackPromise } from 'react-promise-tracker';

import { Overlay } from 'core/overlay/Overlay';
import { useReplies, RepliesActionType } from 'reviews2/feed/review-yeti/Replies.store';
import { ResponseFailedReasonModal } from 'reviews2/feed/review-yeti/reply/custom-actions/failed-reason/ResponseFailedReasonModal';
import { ReplyProps, ResponseState, ResponseFailedReason } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';
import { setResponseState } from 'reviews2/Reviews.api';

import 'reviews2/feed/review-yeti/reply/custom-actions/ReplyCustomActions.scss';

enum KnownActions {
    PostAndClose = 'PostAndClose',
    FailAndClose = 'FailAndClose',
}

export const ReplyCustomActions: FunctionComponent<ReplyProps> = ({ context, reply }) => {
    const { options } = context;
    const [, dispatch] = useReplies();
    const [showModal, setShowModal] = useState(false);
    const showAction = useCallback((action: any, reply: any) => {
        if (!action.showFor?.length) {
            return true;
        }

        return action.showFor?.includes(reply.responseState);
    }, []);
    const OVERLAY_AREA = `reply-custom-actions-${reply.id}`;

    const update = async (reply: any) => {
        dispatch({
            type: RepliesActionType.UpdateReply,
            reply,
        });
    };

    const onSubmit = async (reason: ResponseFailedReason, explanation?: string) => {
        setShowModal(false);

        const callback = options?.repliesOptions?.customActions?.find(
            (action) => action.key === KnownActions.FailAndClose,
        )?.onClick;
        const updatedReply = await trackPromise(
            setResponseState(reply.r4e_tenant_id, reply.document_id, {
                agencyId: reply.r4e_agency_id,
                responseState: ResponseState.Failed,
                responseFailedReason: reason,
                responseFailedReasonExplanation: explanation,
            }),
            OVERLAY_AREA,
        );

        update(updatedReply);
        callback?.(KnownActions.FailAndClose, reply);
    };

    if (!options?.repliesOptions?.showCustomActions) {
        return null;
    }

    return (
        <div className="r4e-reply-custom-actions">
            <Overlay area={OVERLAY_AREA} />
            {options.repliesOptions.customActions?.map((action) => {
                if (showAction(action, reply)) {
                    return (
                        <Button
                            key={action.key}
                            variant={action.variant}
                            disabled={action.disabled}
                            onClick={async () => {
                                switch (action.key) {
                                    case KnownActions.PostAndClose: {
                                        const updatedReply = await trackPromise(
                                            setResponseState(reply.r4e_tenant_id, reply.document_id, {
                                                agencyId: reply.r4e_agency_id,
                                                responseState: ResponseState.Posted,
                                            }),
                                            OVERLAY_AREA,
                                        );

                                        update(updatedReply);
                                        action?.onClick?.(action.key, reply);
                                        break;
                                    }
                                    case KnownActions.FailAndClose: {
                                        setShowModal(true);
                                        break;
                                    }
                                    default: {
                                        action.onClick?.(action.key, reply);
                                        break;
                                    }
                                }
                            }}
                        >
                            <i className={action.icon} />
                            {action.label}
                        </Button>
                    );
                }

                return <></>;
            })}
            <ResponseFailedReasonModal show={showModal} onClose={() => setShowModal(false)} onSubmit={onSubmit} />
        </div>
    );
};
